import Vue from "vue";
import Vuex from "vuex";

Vue.use(Vuex);

export default new Vuex.Store({
  state: {
    currentView:''
  },
  mutations: {
    setView(state,payload){
      state.currentView=payload
    }
  },
  getters:{
    view(state){
      return state.currentView
    }
  },
  actions: {},
  modules: {},
});
